import { EventListRecentlyViewedGrid } from "src/website-apps/shared/components/event-list-recently-viewed-grid";
import { CAROUSEL_SIZES } from "src/website-apps/shared/components/responsive-carousel/constants";
import { renderWithResponsiveCarousel } from "src/website-apps/shared/components/responsive-carousel/util";

/**
 * Unique Wrapper for EventListRecentlyViewedGrid with Responsive Carousel Support on Find
 */
export const FindEventListRecentlyViewedGrid = ({ sellSearch, isPhone }) => {
  // Not shown on the sell experience
  if (sellSearch) {
    return false;
  }

  return (
    <EventListRecentlyViewedGrid
      responsiveCarouselCallBackFunc={
        isPhone
          ? () =>
              renderWithResponsiveCarousel({
                size: CAROUSEL_SIZES.medium,
                hidePaginationButtons: true,
              })
          : () => undefined
      }
    />
  );
};
